import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HtmlTemplate, HtmlTemplateSearchingCriteria } from '@app/models/html-template';


@Injectable()
export class HtmlTemplateService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: HtmlTemplateSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<HtmlTemplate>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new HtmlTemplateSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <HtmlTemplate[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(emailTemplate: HtmlTemplate): Observable<HtmlTemplate> {

        let body = JSON.stringify(emailTemplate);

        return this.httpClient.post(`${environment.API_END_POINT}/htmlTemplate`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <HtmlTemplate[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string): Observable<HtmlTemplate> {
        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <HtmlTemplate>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }


    update(emailTemplate: HtmlTemplate): Observable<HtmlTemplate> {
      
        let body = JSON.stringify(emailTemplate);

        return this.httpClient.put(`${environment.API_END_POINT}/htmlTemplate/${emailTemplate.id}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <HtmlTemplate[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    deploy(templateId: string): Observable<string> {

        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate/deploy/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    // let tempObj = <HtmlTemplate[]>((<any>response).content);
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    findAll(): Observable<HtmlTemplate[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate/all`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <HtmlTemplate[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    findByCondition(columnName:string, columnVal: string): Observable<HtmlTemplate[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate/by/${columnName}/${columnVal}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <HtmlTemplate[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    

    getAllFieldType(): Observable<string[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate/allFieldType`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <string[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    
    htmlTemplateAmount(): Observable<number> {

        return this.httpClient.get(`${environment.API_END_POINT}/htmlTemplate/amount`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <number>((<any>response));
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }
}